import axios from 'axios';
import type {
  EmployeeDashboardData,
  ManagerDashboardData,
  AdminDashboardData,
  ActivityFeedItem,
  ScheduleEntry,
  PreferenceAlert,
  ProjectOverviewEntry,
  TaskEntry,
} from '@/types/dashboard';

const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || '/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const dashboardService = {
  async getEmployeeDashboard(): Promise<EmployeeDashboardData> {
    const res = await apiClient.get('/dashboard/employee');
    return res.data;
  },

  async getManagerDashboard(): Promise<ManagerDashboardData> {
    const res = await apiClient.get('/dashboard/manager');
    return res.data;
  },

  async getAdminDashboard(): Promise<AdminDashboardData> {
    const res = await apiClient.get('/dashboard/admin');
    return res.data;
  },

  async getActivityFeed(limit: number = 10): Promise<ActivityFeedItem[]> {
    const res = await apiClient.get('/dashboard/activity-feed', { params: { limit } });
    return res.data.activityFeed;
  },

  async getTodaySchedule(): Promise<ScheduleEntry[]> {
    const res = await apiClient.get('/dashboard/today-schedule');
    return res.data.todaySchedule;
  },

  async getPreferenceAlerts(): Promise<PreferenceAlert[]> {
    const res = await apiClient.get('/dashboard/preference-alerts');
    return res.data.preferenceAlerts;
  },

  async getProjectsOverview(limit?: number): Promise<ProjectOverviewEntry[]> {
    const res = await apiClient.get('/dashboard/projects-overview', { params: limit ? { limit } : {} });
    return res.data.projects;
  },

  async getMyTasks(limit: number = 10): Promise<TaskEntry[]> {
    const res = await apiClient.get('/dashboard/my-tasks', { params: { limit } });
    return res.data.tasks;
  },
};
